import Honeybadger from '@honeybadger-io/js';
import { isLocal } from 'lib/helpers';

export function notify(error: Error, component: string, context: any) {
  try {
    if (
      error?.name === 'TimeoutError'
      || error?.name === 'AbortError'
      || error?.message?.match(/client closed request/i)
    ) {
      return;
    }
    // We don't want to notify Honeybadger in local environment, but it's helpful to see
    // the error in the console so we can prevent them from happening in production.
    if (isLocal()) {
      console.error(`Not notifying Honeybadger in local environment: ${JSON.stringify({
        component,
        context,
      })}`, error);
      return;
    }
    Honeybadger.notify(error, {
      component,
      context,
    });
  } catch (err) {
    console.error('Error notifying Honeybadger', err);
  }
}
